import StorageManager from '../util/StorageManager'

const STORAGE_KEY = 'OLPHEN_ACCESS_TOKEN'
// 写真展公開サイト側の固定トークン
// ログインしていない場合は、この固定トークンを使用する
const TOKEN = process.env.VUE_APP_TOKEN

/**
 * トークン情報を扱うためのwrapperクラス
 */
class TokenUtil {
  /**
   * 保存
   * @param {*} val
   */
  static set (val) {
    StorageManager.setItem(STORAGE_KEY, val)
  }

  /**
   * 取得
   */
  static get () {
    // 公開用APIのトークンを返す
    let token = StorageManager.getItem(STORAGE_KEY)
    if (!token) token = TOKEN
    return token
  }

  /**
   * トークンの削除
   */
  static remove () {
    StorageManager.removeItem(STORAGE_KEY)
  }

  /**
   * ログイン状態の確認
   */
  static isLogin () {
    return !!StorageManager.getItem(STORAGE_KEY)
  }
  /**
   * 管理側トークン（受賞者本人トークン）かどうかをチェックする処理
   * 管理側トークン（受賞者本人トークン）だった場合 true を返す
   */
  static isAdminLogin () {
    let token = StorageManager.getItem(STORAGE_KEY)
    if (token && token != TOKEN) return true
    return false
  }
}

export default TokenUtil
